/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ category: NonNullable<unknown> }} Directory_Vibebids_Category_LeaderInputs */

const en_directory_vibebids_category_leader = /** @type {(inputs: Directory_Vibebids_Category_LeaderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`#1 in ${i?.category}`)
};

const zh_directory_vibebids_category_leader = /** @type {(inputs: Directory_Vibebids_Category_LeaderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.category} 分类第 1 名`)
};

/**
* | output |
* | --- |
* | "#1 in {category}" |
*
* @param {Directory_Vibebids_Category_LeaderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_category_leader = /** @type {((inputs: Directory_Vibebids_Category_LeaderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Category_LeaderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_category_leader(inputs)
	return zh_directory_vibebids_category_leader(inputs)
});
export { directory_vibebids_category_leader as "directory.vibebids.category_leader" }